import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SoarQueryKeys } from '../queryKeys';
import { matchesEntityScope } from '../routePaths';
import { playbookService } from '../services/playbookService';

export const useTemplates = (entityScope?: string[]) => {
  const {
    data: allTemplates = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: [SoarQueryKeys.TEMPLATES],
    queryFn: () => playbookService.getPlaybookTemplates(),
  });

  const templates = useMemo(
    () => (allTemplates as any[]).filter(t => matchesEntityScope(t?.entityType, entityScope)),
    [allTemplates, entityScope]
  );

  return { templates, isLoading, error };
};
